(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sava-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
  let adding = false;
  let agreed = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  function syncAgreement() {
    const hasItems = Boolean(document.querySelector('cart-drawer .cart-item, #main-cart-items .cart-item'));
    if (!hasItems) agreed = false;
    document.querySelectorAll('[data-sava-policy]').forEach(input => { input.checked = agreed; });
    document.querySelectorAll('[data-sava-checkout]').forEach(button => { button.disabled = !agreed || !hasItems || adding; });
  }
  function sectionTargets() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) return ['cart-drawer', 'cart-icon-bubble'];
    return [document.querySelector('#main-cart-items')?.dataset.id, document.querySelector('#main-cart-footer')?.dataset.id, 'cart-icon-bubble'].filter(Boolean);
  }
  function renderCart(sections, opener) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer'] && sections['cart-icon-bubble']) {
      drawer.classList.remove('is-empty');
      drawer.setActiveElement(opener);
      drawer.renderContents({ sections });
    } else if (!drawer) {
      ['main-cart-items','main-cart-footer','cart-icon-bubble'].forEach(id => {
        const current = document.getElementById(id);
        const key = current?.dataset.id || id;
        if (!current || !sections[key]) return;
        const replacement = parse(sections[key]).getElementById(id);
        if (replacement) current.replaceWith(replacement);
      });
    } else {
      window.location.assign(root() + 'cart');
    }
    watchAgreement();
    syncAgreement();
  }
  class SavaQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const panel = this.querySelector('.sava-qa__panel');
      if (panel.tagName === 'DIALOG') {
        panel.append(this.querySelector('.sava-qa__status'));
        panel.addEventListener('cancel', () => this.close(), options);
      }
      this.addEventListener('click', event => {
        if (event.target.closest('[data-picker-close]')) { this.close(); this.querySelector('.sava-qa__toggle').focus(); return; }
        const toggle = event.target.closest('.sava-qa__toggle');
        if (toggle) {
          event.preventDefault();
          const panel = this.querySelector('.sava-qa__panel');
          const opening = panel.hidden;
          document.querySelectorAll('sava-quick-add').forEach(picker => { if (picker !== this) picker.close(); });
          const direct = panel.querySelector('.sava-qa__add[data-variant-id]');
          if (direct && !adding) { this.add(direct, toggle); return; }
          panel.hidden = !opening;
          if (panel.tagName === 'DIALOG') { if (opening) panel.showModal(); else panel.close(); }
          toggle.setAttribute('aria-expanded', String(opening));
          if (opening) panel.querySelector('button:not(:disabled),select')?.focus({ preventScroll:true });
          return;
        }
        const button = event.target.closest('[data-variant-id]');
        if (button && !button.disabled) { event.preventDefault(); this.add(button, this.querySelector('.sava-qa__toggle')); }
      }, options);
      this.addEventListener('change', () => this.updateOptions(), options);
      this.addEventListener('keydown', event => { if (event.key === 'Escape') { this.close(); this.querySelector('.sava-qa__toggle').focus(); event.stopPropagation(); } }, options);
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    close() { const panel = this.querySelector('.sava-qa__panel'); if (panel) { if (panel.tagName === 'DIALOG' && panel.open) panel.close(); panel.hidden = true; } this.querySelector('.sava-qa__toggle')?.setAttribute('aria-expanded','false'); }
    updateOptions() {
      const json = this.querySelector('[data-variants]');
      if (!json) return;
      const variants = JSON.parse(json.textContent);
      const selects = Array.from(this.querySelectorAll('select'));
      const chosen = selects.map(select => select.value);
      selects.forEach((select,index) => Array.from(select.options).forEach(option => {
        if (!option.value) return;
        option.disabled = !variants.some(variant => variant.available && variant.options[index] === option.value && chosen.every((value,i) => i >= index || !value || variant.options[i] === value));
      }));
      const variant = variants.find(v => v.available && v.options.every((value,index) => value === chosen[index]));
      const button = this.querySelector('[data-multi-add]');
      button.disabled = !variant;
      if (variant) button.dataset.variantId = variant.id;
      else delete button.dataset.variantId;
    }
    async add(button, opener) {
      if (adding || !button.dataset.variantId) return;
      adding = true;
      syncAgreement();
      const status = this.querySelector('.sava-qa__status');
      status.hidden = false; status.textContent = this.dataset.adding;
      this.setAttribute('aria-busy','true');
      const buttons = Array.from(this.querySelectorAll('button')).map(el => [el,el.disabled]);
      buttons.forEach(([el]) => { el.disabled = true; });
      let added = false;
      try {
        const keys = sectionTargets();
        const response = await fetch(root() + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ items:[{id:button.dataset.variantId,quantity:1}], sections:keys, sections_url:window.location.pathname }) });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
        added = true;
        let sections = data.sections;
        if (!sections || keys.some(key => !sections[key])) {
          const refresh = await fetch(root() + '?sections=' + encodeURIComponent(keys.join(',')));
          sections = await refresh.json();
        }
        this.close(); status.hidden = true;
        renderCart(sections, opener);
      } catch (error) {
        if (added) window.location.assign(root() + 'cart');
        else { status.hidden = false; status.textContent = error.message || this.dataset.error; }
      } finally {
        adding = false;
        this.removeAttribute('aria-busy');
        buttons.forEach(([el,disabled]) => { el.disabled = disabled; });
        syncAgreement();
      }
    }
  }
  class SavaProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const track = this.querySelector('.sava-gallery__track');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-image-index]');
        if (button) track.scrollTo({ left:track.clientWidth * Number(button.dataset.imageIndex), behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
      }, { signal:this.abort.signal });
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        this.querySelectorAll('[data-image-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.imageIndex) === index)));
      }, { passive:true, signal:this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  }
  if (!customElements.get('sava-quick-add')) customElements.define('sava-quick-add', SavaQuickAdd);
  if (!customElements.get('sava-product-gallery')) customElements.define('sava-product-gallery', SavaProductGallery);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-sava-policy]')) { agreed = event.target.checked; syncAgreement(); }
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('sava-quick-add')) document.querySelectorAll('sava-quick-add').forEach(picker => picker.close());
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('#cart,#CartDrawer-Form')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    const policy = document.querySelector('[data-sava-policy]');
    if (!agreed || !policy?.checked || adding) {
      event.preventDefault();
      policy?.focus();
      policy?.reportValidity();
    }
  }, true);
  const watched = new WeakSet();
  function watchAgreement() {
    document.querySelectorAll('#CartDrawer,#main-cart-footer').forEach(element => {
      if (watched.has(element)) return;
      watched.add(element);
      new MutationObserver(syncAgreement).observe(element,{childList:true,subtree:true});
    });
  }
  function boot() { watchAgreement(); syncAgreement(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
